// extracted by mini-css-extract-plugin
export default {"Condition":"Condition_Condition__OXtkF"};